import { useEffect, useState } from "react";
import Header from "../components/Header";
import FooterSection from "../components/FooterSection";
import PagesHero from "../components/PagesHero";
import FreeOddSection from "../components/FreeOddSection";
import PreviousWinsSection from "../components/PreviewsWinsSection";
import axios from "axios";

function Expert() {
  const [expertResult, setExpertResult] = useState([]);
  useEffect(() => {
    
    axios
      .get("/result")
      .then(({ data }) => {
        setExpertResult(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <div>
      <Header />
      <PagesHero page={"Expert Tips"} />

      <FreeOddSection title={"expert"} header="Expert Tips" />

      {expertResult.length > 0 && (
        <PreviousWinsSection results={expertResult} />
      )}
      <FooterSection />
    </div>
  );
}

export default Expert;
